var ClientSlider = require('../functions/client-slider');
var QuoteForm = require('../functions/quote-form');
var NewsFilter = require('../functions/news-filter');
var MatchHeight = require('../functions/match-height');
var PageVerticalSlide = require('../functions/page-vertical-slide');
var Share = require('../functions/share');
var Padding = require('../functions/padding');

var attachFastClick = require('fastclick');
var $ = require('jquery');

$(document).ready(function() {
	attachFastClick(document.body);

	var $clientsSlider = $('.clients-slider');
	if($clientsSlider.length) {
		new ClientSlider($clientsSlider, {
			pager: '> .dots',
			'pager-template': '<div class="dot"></div>',
			slides: '.split'
		});
	}

	var $quoteForm = $('.quote-form');
	if($quoteForm.length) new QuoteForm($quoteForm);

	var $filtersWrapper = $('.row .filters');
	var $row = $('.row.-news');
	if($filtersWrapper.length && $row.length) {
		new NewsFilter($row.find('.image-text-overlay-block'), $filtersWrapper, $row.find('.inner'));
	}

	new MatchHeight();

	new PageVerticalSlide();

	new Share();

	new Padding();
});